import WinfinityLogo from '@/assets/headerLogos/winfinity.png'

import type { TenantConfig } from '../types'

import { winfinityTheme } from './winfinity.theme'

export const winfinityConfig: TenantConfig = {
  tenantId: 'winfinity',
  companyName: 'Winfinity',
  logoUrl: WinfinityLogo,
  signInPageLogoUrl: WinfinityLogo,
  favicon: {
    path: '/tenants/winfinity/favicon.ico',
    type: 'image/x-icon',
  },
  title: {
    default: 'Winfinity',
    suffix: ' - Winfinity',
  },
  enabledSystemModules: [
    'admin',
    'auth',
    'my-orders',
    'profile',
    'profiles',
    'shop',
    'allocate-coins',
    'control-feedback',
    'feedback',
    'metrics',
    'privacy-policy',
    'roles-control',
    'tags-control',
    'test',
    'transactions',
    'shop-management',
    'orders-management',
  ],
  locales: [
    {
      code: 'ru',
      name: 'Russian',
    },
    {
      code: 'en',
      name: 'English',
    },
  ],
  defaultLocale: 'ru',
  theme: winfinityTheme,
  featureFlags: {
    employeeThankButton: false,
    useLatinOnlyAddresses: true,
    canViewColleaguesList: false,
  },
  meta: {
    shippingLimit: 'weeks',
    tncUrl: 'https://docs.google.com/document/d/1DW2K5blfqap3P3vxr54qzw2AoDw97VlGg55tHs1UamY/edit?usp=sharing',
  },
}
